import { useFeatureFlagEnabled } from 'posthog-js/react'

/**
 * PostHog flag gating the Microsoft 365 sign-in pill on the login screen.
 *
 * The integration is not planned for release yet, so the flag is created DISABLED: while it is
 * off, the pill does not render at all — not even as a "coming soon" placeholder. Its targeting
 * is pre-wired to the internal team (same @communo.app conditions as the State-SSO flag), so
 * enabling it later is a single toggle that starts as an internal-only rollout.
 */
export const MICROSOFT_SSO_FEATURE_FLAG = 'sso-microsoft'

/**
 * Whether the Microsoft 365 pill may be shown. Defaults to FALSE — `useFeatureFlagEnabled`
 * returns `undefined` while flags load and whenever PostHog is absent (local dev, CI, ad
 * blockers), and an unreleased provider must never flash on screen because analytics was slow.
 */
export function useMicrosoftSsoFeature(): boolean {
  return useFeatureFlagEnabled(MICROSOFT_SSO_FEATURE_FLAG) === true
}
